import React, { Fragment } from 'react';
import styled from '@emotion/styled';

import PageTitle from '../../common/PageTitle';

import { getCollectionImageUrl } from '../../../helpers';
import { Link } from 'react-router-dom';

const getFillTypeString = (fillType) => {
  if (fillType === 'MANUAL') return 'Вручную';
  if (fillType === 'AUTO') return 'Авто';
  return null;
};

const Wrapper = styled('div')`
  .col-card {
    background: white;
    padding: 15px;
    margin-bottom: 5px;
    display: flex;
    &.not-in-catalog {
      opacity: 0.6;
    }
    .image-block {
      height: 50px;
      width: 50px;
      background-repeat: no-repeat;
      background-size: contain;
      margin-right: 15px;
      flex: none;
    }
  }
  .page-title-box {
    margin-bottom: 0 !important;
  }
  .new-order {
    position: fixed;
    right: 6%;
    bottom: 4%;
    z-index: 1;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      display: none;
    }
  }
`;

const TableWrapper = styled('div')`
  .fixed-table-body {
    overflow-x: auto;
  }
  table.table {
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 0;
    tr {
      cursor: pointer;
      &.not-in-catalog {
        opacity: 0.4;
      }
    }
    td {
      vertical-align: middle;
      color: #343a40;
    }
  }
`;

const MobileComponent = ({
  handleAddCollection,
  handleCatalogTuning,
  handleEditCollection,
  collections,
}) => {
  return (
    <Wrapper>
      <PageTitle title="Коллекции" />
      <button
        type="button"
        className="btn btn-primary waves-effect waves-light mb-2"
        onClick={handleCatalogTuning}
      >
        Отображение на сайте
      </button>
      <div className="row">
        <div className="col-12">
          <div>
            <div>
              <div className="row mb-2">
                <div className="col-12">
                  <div className="text-lg-right">
                    <button
                      type="button"
                      className="btn btn-danger waves-effect waves-light mr-2 new-order"
                      onClick={handleAddCollection}
                    >
                      <i className="fe-plus"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div>
                {collections.map((c, i) => (
                  <div
                    key={c.id}
                    onClick={() => handleEditCollection(c.id)}
                    className={`${!c.includedInCatalog ? 'not-in-catalog col-card' : 'col-card'}`}
                  >
                    <div style={{ width: '76px' }}>
                      <div
                        className="image-block"
                        style={{ backgroundImage: `url(${getCollectionImageUrl(c, 100)})` }}
                      />
                    </div>
                    <div>
                      <div className="font-weight-bold mb-1">{c.title}</div>
                      <div>Тип заполнения: {getFillTypeString(c.fillType)}</div>
                      <div>Количество: {c.products ? c.products.length : null}</div>
                      <div className="mt-2" style={{ fontSize: '20px' }}>
                        <i className={c.includedInCatalog ? 'fe-eye' : 'fe-eye-off'} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* <Pagination total={totalItems} onPageSelect={pageIndex => this.handlePageSelect(pageIndex)} /> */}
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default MobileComponent;
